import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"

import arrowLeftIcon from "../../assets/common/arrow-left-nav 2.svg"
import arrowLeftIconDark from "../../assets/common/arrow-line_dark.svg"
import { useDarkMode } from "../../context/DarkModeContext"
import { GlobalContext } from "../../context/GlobalContext"
import data from "../../utils/SideNavData.json"
import Accordion from "../Accordion"
import { userRoles } from "../Utility/userRoles"

export function SideBar() {
    const { t } = useTranslation()
    const { isDarkMode } = useDarkMode()
    const { hamburger } = useContext(GlobalContext)
    const { isUserManagement, isProductsManagement } = useContext(GlobalContext)
    
    // Choose arrow icon based on dark mode
    const arrowImage = isDarkMode ? arrowLeftIconDark : arrowLeftIcon
    localStorage.setItem("sideBarMenu", JSON.stringify(data?.sideNav))
    const { sideNav } = data
    const menus = () => {
        let menuObject = []
        sideNav.map((key) => {
            if (key?.subMenu) {
                menuObject.push(key?.subMenu)
            }
        })
    }
    menus()

    const hasMenuPermission = (permissionId) => {
        let tempVar = []
        if (Array.isArray(permissionId)) {
            tempVar = permissionId.map((activityID) => {
                return userRoles().findUserRolesForPage(activityID)
            })
            return tempVar.find((activeID) => activeID?._read) ? { _read: true } : { _read: false }
        } else {
            return userRoles().findUserRolesForPage(permissionId)
        }
    }
    const userManagementMenus = [...(data?.userManagementNav || [])].sort((a, b) => a.title.localeCompare(b.title))
    const productManagementNav = [...(data?.productManagementNav || [])].sort((a, b) => a.title.localeCompare(b.title))

    return (
        <div>
            { isUserManagement ? (
                <div className={ `${hamburger && "hidden"}` }>
                    <ul className="flex flex-col gap-3">
                        { userManagementMenus.map((userNavItem, i) => {
                            const isMenuPermission = hasMenuPermission(userNavItem.activity_id)
                            if (isMenuPermission?._read) {
                                return (
                                    <li key={ i }>
                                        <div className="flex">
                                            <img
                                                alt="ArrowLeft"
                                                src={ arrowImage }
                                                className="pr-1 w-[20px] h-[20px]"
                                                height={ "10px" }
                                                width={ "20px" }
                                            />                            <NavLink
                                                to={ userNavItem.path }
                                                className="nav-link text-sm text-primary-100 dark:text-darkText nav-link-subnav"
                                            >
                                                { t(`ManageUser.${userNavItem.title}`) }
                                            </NavLink>
                                        </div>
                                    </li>
                                )
                            }

                        }) }
                    </ul>
                </div>
            ) : isProductsManagement ? (
                <div className={ `${hamburger && "hidden"}` }>
                    <ul className="flex flex-col gap-3">
                        { productManagementNav.map((userNavItem, i) => {
                            const isMenuPermission = hasMenuPermission(userNavItem.activity_id)
                            if (isMenuPermission?._read) {
                                return (
                                    <li key={ i }>
                                        <div className="flex">
                                            <img
                                                alt="ArrowLeft"
                                                src={ arrowImage }
                                                className="pr-1 w-[20px] h-[20px]"
                                                height={ "10px" }
                                                width={ "20px" }
                                            />                            <NavLink
                                                to={ userNavItem.path }
                                                className="nav-link text-sm text-primary-100 dark:text-darkText nav-link-subnav"
                                            >
                                                { t(`productManagement.${userNavItem.title}`) }
                                            </NavLink>
                                        </div>
                                    </li>
                                )
                            }
                        }) }
                    </ul>
                </div>
            ) : (
                <Accordion data={ data?.sideNav }></Accordion>
            ) }
        </div>
    )
}
